import { P } from 'components'
import MonthSelectPlugin from 'flatpickr/dist/plugins/monthSelect'
import moment from 'moment-timezone'
import { useEffect, useRef } from 'react'
import { Calendar } from 'react-feather'
import Flatpickr from 'react-flatpickr'
import { Button, FormGroup, Input, Modal, ModalBody, Spinner } from 'reactstrap'

const ModalSetTilte = ({
  isOpen,
  toggle,
  payload,
  resetState,
  isFormInvalid,
  handleSubmit,
  handleTitleChange,
  handlePeriodeChange,
  isLoadingAddReport,
  isEditMode,
  isListReport,
}) => {
  const inputRef = useRef(null)

  // AUTO FOCUS
  useEffect(() => {
    if (isOpen) setTimeout(() => inputRef.current?.focus(), 100)
  }, [isOpen])

  // RESET STATE PAYLOAD
  useEffect(() => {
    if (!isOpen) {
      const timeout = setTimeout(() => {
        resetState()
      }, 300)

      return () => clearTimeout(timeout)
    }
  }, [isOpen])

  const handleChangeMonthYear = (selectedDates) => {
    if (selectedDates.length > 0) {
      const date = selectedDates[0]
      handlePeriodeChange(moment(date).format('YYYY-MM'))
    }
  }

  return (
    <>
      <Modal
        className="p-4"
        centered
        isOpen={isOpen}
        toggle={toggle}
        autoFocus={false}
        style={{ maxWidth: '600px' }}
        data-testid="pnbp-modal-set-title"
      >
        <ModalBody>
          <div className="d-flex flex-column gap-1">
            <P className="text-sm pb-4" size="medium" color="#101828" bold>
              {isEditMode ? 'Ubah Judul Laporan' : 'Tambah Judul Laporan'}
            </P>
          </div>

          <FormGroup>
            <div className="d-flex align-items-center">
              <P className="text-sm me-1" size="regular" color="#344054">
                Judul<span style={{ color: '#b42218' }}>*</span>
              </P>
            </div>
            <Input
              placeholder="Masukkan judul"
              autoComplete="off"
              name="title"
              id="title"
              onChange={(e) => handleTitleChange(e.target.value)}
              value={payload?.title ?? null}
              // invalid={!payload?.title}
              autoFocus
            />
          </FormGroup>

          <FormGroup>
            <div className="d-flex align-items-center">
              <P className="text-sm me-1" size="regular" color="#344054">
                Periode<span style={{ color: '#b42218' }}>*</span>
              </P>
            </div>
            {/* <Input
              placeholder="Masukkan periode"
              autoComplete="off"
              name="periode"
              id="periode"
              onChange={(e) => handlePeriodeChange(e.target.value)}
              value={payload?.periode ?? null}
              // invalid={!payload?.periode}
            /> */}
            <div
              className="d-flex align-items-center border rounded"
              style={{ height: 42 }}
            >
              <Calendar size={17} className="ms-3" />
              <Flatpickr
                value={
                  payload?.periode
                    ? moment(payload?.periode).format('YYYY-MM')
                    : moment().format('YYYY-MM')
                }
                onChange={handleChangeMonthYear}
                options={{
                  altInput: true,
                  altFormat: 'F Y',
                  dateFormat: 'Y-m',
                  defaultDate: payload?.periode
                    ? moment(payload?.periode).format('YYYY-MM')
                    : moment().format('YYYY-MM'),
                  disableMobile: true,
                  plugins: [
                    new MonthSelectPlugin({
                      shorthand: false,
                      dateFormat: 'Y-m',
                      altFormat: 'F Y',
                    }),
                  ],
                }}
                className="form-control bg-transparent border-0 shadow-none"
              />
            </div>
          </FormGroup>

          <div className="d-flex gap-3 mt-3">
            <Button
              onClick={() => toggle()}
              className="btn-cancel"
              outline
              block
              data-testid="pnbp-modal-set-title-cancel"
            >
              Batal
            </Button>
            <Button
              color="primary"
              block
              disabled={isFormInvalid || isLoadingAddReport}
              onClick={handleSubmit}
              data-testid="pnbp-modal-set-title-submit"
            >
              {isLoadingAddReport && <Spinner size="sm" className="me-2" />}
              {isListReport ? 'Lanjutkan' : 'Simpan'}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default ModalSetTilte
